import {apiClient} from '@/core/apiClient';
import {publicClient} from '@/core/publicClient';

export type ShelterSignupStatus = 'new' | 'in_review' | 'approved' | 'rejected';

export type ShelterSignupRequest = {
  id: number;
  shelterName: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  cityId?: number | null;
  city?: {id: number; name?: string; department?: string} | null;
  status: ShelterSignupStatus;
  rejectionReason?: string | null;
  reviewedByUserId?: number | null;
  reviewedByUser?: {id: number; fullName?: string; email?: string} | null;
  convertedShelterId?: number | null;
  convertedShelter?: {id: number; name?: string} | null;
  createdAt?: string;
  updatedAt?: string;
};

export const shelterSignupsApi = {
  createPublic: async (payload: {
    shelterName: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    cityId: number;
  }) => {
    const response = await publicClient.post('/public/shelter-signup-requests', payload);
    return response.data as ShelterSignupRequest;
  },

  listAdmin: async (params?: {status?: ShelterSignupStatus}) => {
    const response = await apiClient.get('/admin/shelter-signup-requests', {params});
    return response.data as ShelterSignupRequest[];
  },

  countNew: async () => {
    const response = await apiClient.get('/admin/shelter-signup-requests/count-new');
    return Number(response.data?.count ?? 0);
  },

  updateStatus: async (id: number, payload: {status: ShelterSignupStatus; rejectionReason?: string | null}) => {
    const response = await apiClient.patch(`/admin/shelter-signup-requests/${id}/status`, payload);
    return response.data as ShelterSignupRequest;
  },
};
